import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { zNote, zodPagination } from "@dobrh-monorepo/core";

const requestSchema = z.object({
  type: z.union([z.literal("private"), z.literal("shared"), z.literal("all")]).default("all"),
  searchText: z.string().optional(),
  ...zodPagination(),
});

const responseSchema = z.object({
  list: z.array(zNote),
  count: z.number(),
});

export default {
  method: HttpMethodEnum.GET,
  paramsType: HttpParamsTypeEnum.QUERY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
